import { menuSeconds } from 'constants/menus'
import EditNhsoTreatment from 'features/counter/nhso-treatment/edit-nhso-treatment'
import NhsoTreatment from 'features/counter/nhso-treatment/nhso-treatment'
import { routeName } from 'routes/routes-name'


const routeNhsoTraetment = [
    {
        ...menuSeconds.NHSO_TREATMENT,
        component: NhsoTreatment,
        appBar: true
    },
    {
        ...menuSeconds.NHSO_TREATMENT,
        path: routeName.editNhsoTreatment,
        component: EditNhsoTreatment,
        appBar: true
    }
]

export default routeNhsoTraetment
